var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM11.4146 14.3808C11.6091 14.5542 11.7084 14.8089 11.682 15.0666V24.3455C11.7397 24.6802 11.6331 25.0221 11.3948 25.2665L9.16667 27.9414V28.2941H15.4847V27.9414L13.2566 25.2665C13.0166 25.0225 12.9034 24.6829 12.9496 24.3455V16.3208L18.4952 28.2941H19.1389L23.9023 16.3208V25.8642C23.9023 26.1189 23.9023 26.1679 23.7339 26.3345L22.0207 27.9806V28.3333H30.3392V27.9806L28.6854 26.3737C28.5394 26.2636 28.467 26.0826 28.4972 25.9034V14.0966C28.467 13.9174 28.5394 13.7364 28.6854 13.6263L30.3788 12.0194V11.6667H24.5162L20.3372 21.9841L15.5838 11.6667H9.43405V12.0194L11.4146 14.3808Z",
    fill: "#006AED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.4c6022c86b187cefc24bde3334adf6d9.svg";
export { ForwardRef as ReactComponent };